// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//


import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { checkoutPages } from "@waytek/Utilities/constants";

/**
 * PopulateApiParameter adds shippign expand after add to cart
 * We don't need shipping data outside checkout pages
 * @param props 
 */
export const XngRemoveShippingExpand: typeof PopulateApiParameter = props => {
    if(!checkoutPages.includes(getCurrentPage(props.getState()).type)) {
        props.apiParameter.expand = props.apiParameter.expand?.filter(e => e !== "shipping");
    }
};

addToChainAfter(chain, PopulateApiParameter, XngRemoveShippingExpand);